export default "__VITE_ASSET__C1Gl7OtQ__"